function initShops() {
  const slider = document.querySelector('.shops__slider');

  if (!slider) {
    return;
  }

  const swiper = new Swiper(slider, {
    slidesPerView: 3,
    spaceBetween: 20,

    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      }
    },

    navigation: {
      nextEl: '.shops__slider .swiper-navigation__btn--next',
    },
  });
}

export { initShops };